import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import gggLogo from "@/assets/logos/ggg-logo-final.webp";
import { useAdminAuth } from "@/admin/AdminAuthContext";

const AdminLogin = () => {
  const { user, loading, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err?.response?.data?.detail || "Invalid email or password.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--gg-bg-black)" }} data-testid="admin-login-page">
      <div className="neu-panel w-full max-w-[420px] p-10">
        <div className="flex flex-col items-center mb-8">
          <img src={gggLogo} alt="Gopi Gadhvi Group" className="h-16 w-auto object-contain mb-4" />
          <span className="eyebrow flex items-center gap-2"><Lock size={12} /> Command Centre</span>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="text-small font-semibold uppercase tracking-wide block mb-2" style={{ color: "var(--gg-secondary-text)" }}>Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email-input"
              className="neu-inset w-full h-12 px-4 text-[16px] font-sans"
              style={{ color: "var(--gg-ivory)" }}
            />
          </div>
          <div>
            <label className="text-small font-semibold uppercase tracking-wide block mb-2" style={{ color: "var(--gg-secondary-text)" }}>Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password-input"
              className="neu-inset w-full h-12 px-4 text-[16px] font-sans"
              style={{ color: "var(--gg-ivory)" }}
            />
          </div>

          {error && <p className="text-small" style={{ color: "#E39B9B" }} data-testid="admin-login-error">{error}</p>}

          <button type="submit" disabled={submitting} className="btn-solid-pearl w-full" data-testid="admin-login-submit-btn">
            {submitting ? <Loader2 size={16} className="animate-spin mr-2" /> : null}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
